import { getForeignId, setForeignId } from '@/utils/objUtil'
import { getDatetimeOrNull } from '@/utils/dateUtil'
import { BaseModel } from './BaseModel'
import { toListFields, defaultAuthorizee, authProductMap } from '@/views/cpTask/const'

// 默认合同备注
export const defaultCopyrightExtend = () => {
  return {
    attrRemarks: '',
    authTypeRemarks: '',
    isAllSongbankRemarks: '',
    isOnlyRemarks: '',
    canAuthRemarks: '',
    authPlatformRemarks: '',
    authProductRemarks: '',
    authTerminalRemarks: '',
    authFormRemarks: '',
    cooFactoryRemarks: '',
    canLegalRightsRemarks: '',
    otherRightRemarks: '',
    canClipRemarks: '',
    networkRemarks: '',
    copyrightAreaRemarks: '',
    isOverseaOnlyRemarks: '',
    excludePlatformRemarks: '',
    otherLimitRemarks: '',
    remarks: '',
    noLinkRemarks: '',
    canCoverRemarks: '',
    overseaStatusRemarks: '',
    settleMethodRemarks: '',
    onlyTypeRemarks: ''
  }
}
export const remarkShow = (Object.keys(defaultCopyrightExtend()).reduce((result, field) => {
  result[field + 'Show'] = false

  return result
}, {}))

// 默认权利备注
export const defaultCopyrightDetailExtend = () => {
  return {
    ...defaultCopyrightExtend(),
    terminalLimitRemarks: '',
    formLimitRemarks: '',
    excludeAreaRemarks: '',
    networkLimitRemarks: '',
    productLimitRemarks: '',
    productLimitTermsRemarks: '',
    propertyRightLimitRemarks: '',
  }
}
export const detailRemarkShow = (Object.keys(defaultCopyrightDetailExtend()).reduce((result, field) => {
  result[field + 'Show'] = false

  return result
}, {}))

// 合同权利类
export class CpDetail extends BaseModel {
  authProductLabel = '新增权利'
  isOnly = 0 // 是否首发
  canAuth = 0 // 是否可转售
  authPlatform = [] // 授权平台
  authProduct = [] // 授权产品
  authTerminal = [] // 授权终端
  authForm = [] // 授权形式
  cooFactory = 0
  canLegalRights = 0
  otherRight = []
  canClip = 0
  network = []
  copyrightArea = []

  date = []
  copyrightFrom = void (0)
  copyrightTo = void (0)

  isOverseaOnly = 0
  overseaStatus = 0
  excludePlatform = []
  canCover = 0
  canCoverFrom = void (0)
  canCoverTo = void (0)
  excludeArea = []
  excludeAreaTerms = ''
  productLimit = []
  productLimitTerms = ''
  terminalLimit = []
  terminalLimitTerms = ''
  formLimit = []
  formLimitTerms = ''
  networkLimit = []
  networkLimitTerms = ''
  resaleProduct = []
  srcInReceiver = 0
  onlyWholeTime = 0
  onlyDuration = 0
  propertyRight = 1
  propertyRightLimit = []

  copyrightDetailExtend = defaultCopyrightDetailExtend()
  remarkShow = { ...detailRemarkShow }

  constructor(initObj) {
    super()

    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    parseMultiFieldsAndDate(this, initObj)
    this.authProductLabel = this.authProduct.map(item => authProductMap[item]).join(',') || '新增权利'
  }

  getBackendData() {
    const postData = super.getBackendData()
    multiFieldsAndDateToBackend(postData)

    // 处理翻唱逻辑
    if (postData.canCover !== 1) {
      postData.canCoverFrom = null
      postData.canCoverTo = null
      postData.coverNeedPermission = 0
    } else {
      postData.canCoverFrom = getDatetimeOrNull(postData.canCoverFrom)
      postData.canCoverTo = getDatetimeOrNull(postData.canCoverTo)
    }

    return postData
  }
}

// 合同类
export class Cp extends BaseModel {
  onLink = 0
  originalDate = []
  originalCopyrightFrom = void (0)
  originalCopyrightTo = void (0)

  copyrightId = 0
  contract = ''
  isDefault = 0
  isFree = 0
  authType = 1
  wmAuthType = 0
  isAllSongbank = 0
  isOnly = 0
  canAuth = 0
  authPlatform = []
  authProduct = []
  authTerminal = []
  authForm = []
  cooFactory = []
  canLegalRights = 0
  otherRight = []
  canClip = 0
  network = []
  copyrightArea = []

  date = []
  copyrightFrom = void (0)
  copyrightTo = void (0)

  isOverseaOnly = 0
  overseaStatus = 0
  excludePlatform = []
  otherLimit = ''
  cpCompanyId = ''
  authorizer = '' // 授权方
  originalObligee = ''
  attr = []
  licenseValid = 0
  rightComplete = 0
  companyType = 0
  copyrightType = 0
  noLink = 0
  canCover = 0
  coverNeedPermission = 0
  canCoverFrom = void (0)
  canCoverTo = void (0)
  businessBroker = ''
  settleMethod

  signPlatform = []
  signBusinessTeam = 0
  settleTerms = ''
  signForm = 0
  isVirtual = 0
  belongTo = 0
  onlyType = 0
  authorizee = defaultAuthorizee[0].value // 被授权主体
  authorizeeName = ''

  // 控制字段，不在合同表中
  autoWord = 0
  autoMusic = 0
  wmRelate = 0

  // 合同备注字段
  copyrightExtend = defaultCopyrightExtend()
  remarkShow = { ...remarkShow }

  // 权利字段
  copyrightDetailList = [new CpDetail()] // 合同权利列表

  constructor(initObj) {
    super()

    this._collectProperties()

    if (initObj) {
      this._setValues(initObj)

      this.init(initObj)
    }
  }

  init(initObj) {
    // 处理厂牌
    getForeignId(this, 'cpCompanyId', 'companyId', 'companyName')

    // 处理商务签约团队
    this.signBusinessTeam = +initObj.signBusinessTeam

    // 处理授权方
    this.authorizee = initObj.authorizee && initObj.authorizeeName ? `${initObj.authorizee} -@- ${initObj.authorizeeName}` : defaultAuthorizee[0].value

    // 处理多选字段和日期
    parseMultiFieldsAndDate(this, initObj)

    // 处理权利
    this.copyrightDetailList = (initObj.copyrightDetailList || []).map(detail => new CpDetail(detail))
  }

  getBackendData() {
    const postData = super.getBackendData()

    // 处理厂牌
    setForeignId(postData, 'cpCompanyId', 0)
    // 处理授权方
    postData.authorizee = postData.authorizee ? postData.authorizee.split(' -@- ')[0] : 0

    // 处理多选字段和日期
    multiFieldsAndDateToBackend(postData)

    // 处理权利
    postData.copyrightDetailList = this.copyrightDetailList.map(detail => detail.getBackendData())

    return postData
  }
}

// 部分多选字段需要拆分成数组，授权时间需要合并成数组
function parseMultiFieldsAndDate(instance, initObj) {
  if (!initObj) return

  toListFields.forEach(field => {
    const str = initObj[field]
    instance[field] = str ? str.split(',').filter(Boolean).map(Number) : []
  })

  if (initObj.copyrightFrom && initObj.copyrightTo) {
    instance.date = [initObj.copyrightFrom, initObj.copyrightTo]
  }

  if (initObj.originalCopyrightFrom && initObj.originalCopyrightTo) {
    instance.originalDate = [initObj.originalCopyrightFrom, initObj.originalCopyrightTo]
  }
}

/**                                    后台相关处理函数                                         */
// 部分多选字段需要重新合并成字符串，授权时间拆分字段
function multiFieldsAndDateToBackend(obj) {
  toListFields.forEach(field => {
    const arr = obj[field]
    obj[field] = arr ? arr.join(',') : undefined
  })

  if (obj.date) {
    obj.copyrightFrom = getDatetimeOrNull(obj.date[0])
    obj.copyrightTo = getDatetimeOrNull(obj.date[1], '23:59:59')
  }

  if (obj.originalDate) {
    obj.originalCopyrightFrom = getDatetimeOrNull(obj.originalDate[0])
    obj.originalCopyrightTo = getDatetimeOrNull(obj.originalDate[1], '23:59:59')
  }
}
